import { render, staticRenderFns } from "./BadgePill.vue?vue&type=template&id=e66fd878"
import script from "./BadgePill.vue?vue&type=script&lang=js"
export * from "./BadgePill.vue?vue&type=script&lang=js"
import style0 from "./BadgePill.vue?vue&type=style&index=0&id=e66fd878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports